module.exports = __webpack_public_path__ + "static/img/gpt74.f244f908.png";